import script from "./PortfolioBaseTokenSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioBaseTokenSelect.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioBaseTokenSelect.vue?vue&type=style&index=0&id=25cd3eca&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cd3eca"]])

export default __exports__